'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CommunityVideoPlayer = require('../../CommunityVideoPlayer');

var _CommunityVideoPlayer2 = _interopRequireDefault(_CommunityVideoPlayer);

var _FollowUserLink = require('../FollowUserLink');

var _FollowUserLink2 = _interopRequireDefault(_FollowUserLink);

var _FormattedViews = require('../../shared/FormattedViews');

var _FormattedViews2 = _interopRequireDefault(_FormattedViews);

var _Uniform = require('../../Uniform');

var _propTypes = require('../../../shared/prop-types');

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _urls = require('../../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

var _services = require('../../../utils/services');

var _services2 = _interopRequireDefault(_services);

var _feedUserUtil = require('../../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _getHighestQualityVideoUrl = require('../../../utils/getHighestQualityVideoUrl');

var _getHighestQualityVideoUrl2 = _interopRequireDefault(_getHighestQualityVideoUrl);

var _displayHelpers = require('../../../utils/display-helpers');

var _mobileUtil = require('../../../utils/mobile-util');

var _mobileUtil2 = _interopRequireDefault(_mobileUtil);

var _hudlBase = require('hudl-base');

var _generatePlayerId = require('../../../utils/generatePlayerId');

var _generatePlayerId2 = _interopRequireDefault(_generatePlayerId);

var _hudlG11n = require('hudl-g11n');

var _hudlG11n2 = _interopRequireDefault(_hudlG11n);

var _i18nKeys = require('../../../shared/i18n-keys');

var _i18nKeys2 = _interopRequireDefault(_i18nKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormattedMessage = _hudlG11n2.default.ReactIntl.FormattedMessage;

var raw = _hudlBase.data.raw() || {};

var _ref = raw.data || {},
    analyticsIdentifyData = _ref.analyticsIdentifyData,
    highlightEditorFeaturePrivileges = _ref.highlightEditorFeaturePrivileges;

var _Services$routes = _services2.default.routes,
    highlightsPresign = _Services$routes.highlightsPresign,
    highlightsUploadCredentials = _Services$routes.highlightsUploadCredentials;

var SharedHighlight = function (_PureComponent) {
  _inherits(SharedHighlight, _PureComponent);

  function SharedHighlight(props) {
    _classCallCheck(this, SharedHighlight);

    var _this = _possibleConstructorReturn(this, (SharedHighlight.__proto__ || Object.getPrototypeOf(SharedHighlight)).call(this, props));

    _this.onClick = function () {
      var thumbnailWidth = _this.refs.container.getBoundingClientRect().width;
      var aspectRatio = 9 / 16;
      var thumbnailHeight = thumbnailWidth * aspectRatio;

      if (_this.props.isHudlProducedSuggestion) {
        var videoUrl = (0, _getHighestQualityVideoUrl2.default)(_this.props.videoFiles);
        _this.setState({
          isPlaying: true,
          embedHeight: thumbnailHeight + 'px',
          videoSource: videoUrl
        });
      } else {
        _this.setState({
          isPlaying: true,
          embedHeight: thumbnailHeight + 'px'
        });
      }
    };

    _this.onVideoOverlayClick = function () {
      // We only support desktop browsers for theatre view right now
      if (_this.hasImmersiveView()) {
        if (!_this.useVideoInterface()) {
          _this.setState({ isPlaying: false });
        }
        _this.props.onVideoOverlayClick();
      }
    };

    _this.onPublishHighlight = function () {
      if (!!_this.state.isPublishSuccess) {
        return;
      }

      var highlightOwnerType = _feedUserUtil2.default.getHighlightOwnerType(_this.props.ownerId.type);
      _this.setState({
        isPublishRequest: true,
        isPublishSuccess: false,
        isPublishFail: false
      });

      _services2.default.publishHighlight(highlightOwnerType, _this.props.ownerId.relatedId, _this.props.reelId).done(function () {
        _this.setState({
          isPublishRequest: false,
          isPublishSuccess: true
        });
        setTimeout(function () {
          var highlightUrl = _urls2.default.getPublicHighlightUrl(_this.props.ownerId.type, _this.props.ownerId.relatedId, _this.props.reelId);

          var notification = {
            body: _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'a',
                { href: highlightUrl, target: '_blank' },
                'Your highlight'
              ),
              '\xA0 has been saved & published to your profile'
            ),
            className: 'success'
          };
          _this.props.onShareContent(notification, 'Share Your Highlight', true);
        }, 300);
      }).fail(function () {
        _this.setState({
          isPublishRequest: false,
          isPublishFail: true
        });
      });
    };

    _this.onEditHighlight = function () {
      var HighlightsEditor = window.HighlightsEditor;
      if (HighlightsEditor) {
        var highlightOwnerType = _feedUserUtil2.default.getHighlightOwnerType(_this.props.ownerId.type);
        var options = {
          ownerType: highlightOwnerType,
          ownerId: _this.props.ownerId.relatedId,
          // Eventually we'll fully remove analyticsIdentifyData, but for now we're allowing marvel services
          // (that don't have analyticsIdentifyData) to pass in highlightEditorIdentifyData
          // (same shape as analyticsIdentifyData) to run the highlights editor
          analyticsIdentifyData: _this.props.highlightEditorIdentityData || analyticsIdentifyData,
          featurePrivileges: highlightEditorFeaturePrivileges || [],
          endpoints: {
            uploadCredentials: highlightsUploadCredentials,
            presign: highlightsPresign
          }
        };

        HighlightsEditor.loadReelById(_this.props.reelId, options, function () {
          _this.setState({
            isPublishSuccess: true
          });
          (0, _displayHelpers.enablePageScroll)();
        }, function () {
          return (0, _displayHelpers.enablePageScroll)();
        }, function () {
          return (0, _displayHelpers.disablePageScroll)();
        });
      } else {
        console.error('Missing window.HighlightsEditor plugin');
      }
    };

    _this.state = {
      isPlaying: false,
      normalPlayerId: (0, _generatePlayerId2.default)(props.feedContentId),
      suggestionPlayerId: (0, _generatePlayerId2.default)(props.feedContentId)
    };
    return _this;
  }

  _createClass(SharedHighlight, [{
    key: 'hasImmersiveView',
    value: function hasImmersiveView() {
      return this.props.onVideoOverlayClick && !_mobileUtil2.default.isMobileOrTablet();
    }
  }, {
    key: 'useVideoInterface',
    value: function useVideoInterface() {
      return !_mobileUtil2.default.isMobileOrTablet();
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      if (this.state.isPlaying) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'video-container', ref: 'container', onClick: this.onClick },
        _react2.default.createElement(
          'div',
          { className: 'video-thumb-overlay' + (this.props.isFeatured ? ' featured-highlight-overlay' : '') },
          this.props.isFeatured ? _react2.default.createElement(
            'div',
            { className: 'featured-highlight' },
            _react2.default.createElement(
              'span',
              { className: 'featured-highlight-text' },
              'Pinned Highlight'
            ),
            _react2.default.createElement(
              'span',
              { className: 'featured-highlight-title' },
              this.props.title
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { className: 'play-video' },
            _react2.default.createElement(_Uniform.Icon, { type: 'play' })
          ),
          _react2.default.createElement('img', { className: 'video-thumbnail', src: this.props.thumbnail.url })
        )
      );
    }
  }, {
    key: 'renderVideo',
    value: function renderVideo() {
      if (!this.state.isPlaying) return null;

      var _props = this.props,
          communityContentId = _props.communityContentId,
          logData = _props.logData;

      if (this.props.isHudlProducedSuggestion) {
        return _react2.default.createElement(
          'div',
          { className: 'embeddable-video', style: this.state.embedHeight ? { height: this.state.embedHeight } : null },
          _react2.default.createElement(_CommunityVideoPlayer2.default, {
            autoplay: true,
            communityContentId: communityContentId,
            logData: logData,
            onVideoOverlayClick: this.onVideoOverlayClick,
            playerId: this.state.suggestionPlayerId,
            playables: [{
              src: this.state.videoSource,
              communityContentId: communityContentId
            }]
          })
        );
      }

      var highlightUrl = null;
      if (this.props.ownerId) {
        highlightUrl = _urls2.default.getHighlightEmbedUrl(this.props.ownerId.type, this.props.ownerId.relatedId, this.props.reelId, true);
      } else if (this.props.userId) {
        highlightUrl = _urls2.default.getAthleteHighlightEmbedUrl(this.props.userId, this.props.reelId, true);
      } else if (this.props.teamId) {
        highlightUrl = _urls2.default.getTeamHighlightEmbedUrl(this.props.teamId, this.props.reelId, true);
      }

      highlightUrl = (0, _urijs2.default)(highlightUrl);
      if (this.props.forcePublicView) {
        highlightUrl.addQuery('forcePublicView', true);
      }
      if (this.props.isTimeline) {
        highlightUrl.addQuery('isTimeline', true);
      }

      if (this.useVideoInterface()) {
        var _props2 = this.props,
            adTag = _props2.adTag,
            durationMs = _props2.durationMs,
            videoFiles = _props2.videoFiles;

        var playables = [{
          src: (0, _getHighestQualityVideoUrl2.default)(videoFiles),
          communityContentId: communityContentId
        }];

        return _react2.default.createElement(
          'div',
          { className: 'embeddable-video', style: this.state.embedHeight ? { height: this.state.embedHeight } : null },
          _react2.default.createElement(_CommunityVideoPlayer2.default, {
            adTag: adTag,
            autoplay: true,
            durationMs: durationMs,
            logData: logData,
            playerId: this.state.normalPlayerId,
            playables: playables,
            onVideoOverlayClick: this.onVideoOverlayClick
          })
        );
      }

      // React 15 doesn't support 'allow' attribute so dangerouslySetInnerHTML is a away around it.
      var iframe = {
        __html: '<iframe\n        src="' + highlightUrl.toString() + '"\n        width="400"\n        height="225"\n        allow="autoplay; fullscreen"\n        allowFullscreen>\n      </iframe>'
      };

      return _react2.default.createElement('div', { className: 'embeddable-video',
        style: this.state.embedHeight ? { height: this.state.embedHeight } : null,
        dangerouslySetInnerHTML: iframe });
    }
  }, {
    key: 'render',
    value: function render() {
      var subtitle = void 0;
      if (this.props.isHudlProducedSuggestion) {
        subtitle = this.props.subtitle;
      } else if (typeof this.props.views !== 'undefined') {
        subtitle = _react2.default.createElement(_FormattedViews2.default, { views: this.props.views, capitalize: true });
      } else if (!!this.props.subtitle) {
        subtitle = this.props.subtitle;
      }

      var publishStatus = null;
      var publishButtonText = 'Publish';
      if (this.state.isPublishRequest) {
        publishStatus = 'spinning';
      } else if (this.state.isPublishSuccess) {
        publishStatus = 'success';
        publishButtonText = 'Publishing';
      } else if (this.state.isPublishFail) {
        publishStatus = 'failure';
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _Uniform.CardMedia,
          null,
          _react2.default.createElement(
            'div',
            { className: 'media-container' },
            this.renderPreview(),
            this.renderVideo()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content-description' },
          !!this.props.title && !this.props.isFeatured ? _react2.default.createElement(
            _Uniform.Subhead,
            { className: 'uni-margin--one--top' },
            this.props.title
          ) : null,
          !!subtitle && _react2.default.createElement(
            _Uniform.Text,
            { level: 'small', color: 'subtle', isTight: true, className: 'uni-margin--half--top' },
            subtitle
          )
        ),
        this.props.includeFollowButton && this.props.relatedFeedUser && _react2.default.createElement(_FollowUserLink2.default, {
          currentUserId: this.props.currentUserId,
          feedUser: this.props.relatedFeedUser
        }),
        this.props.isHudlProducedSuggestion ? _react2.default.createElement(
          'div',
          { className: 'uni-btn__row highlight-cta-buttons' },
          _react2.default.createElement(_Uniform.Button, { type: 'subtle', text: 'Edit',
            onClick: this.onEditHighlight,
            disabled: this.state.isPublishRequest ? true : false }),
          _react2.default.createElement(_Uniform.Button, { type: 'primary', text: publishButtonText,
            status: publishStatus,
            disabled: this.state.isPublishRequest ? true : false,
            onClick: this.onPublishHighlight })
        ) : null,
        this.props.isRendering && _react2.default.createElement(
          'div',
          { className: 'rendering-overlay' },
          _react2.default.createElement(
            'span',
            { className: 'rendering-text uni-headline--2' },
            _react2.default.createElement(FormattedMessage, {
              id: _i18nKeys2.default.highlightRendering,
              defaultMessage: 'This highlight is rendering. Check back in a minute or two.'
            })
          )
        )
      );
    }
  }]);

  return SharedHighlight;
}(_react.PureComponent);

SharedHighlight.propTypes = {
  adTag: _propTypes.adTagShape,
  communityContentId: _propTypes.CommunityContentId.isRequired,
  currentUserId: _react.PropTypes.string,
  durationMs: _react.PropTypes.number,
  feedContentId: _react.PropTypes.string.isRequired,
  forcePublicView: _react.PropTypes.bool,
  includeFollowButton: _react.PropTypes.bool,
  isHudlProducedSuggestion: _react.PropTypes.bool,
  isFeatured: _react.PropTypes.bool,
  isRendering: _react.PropTypes.bool,
  isTimeline: _react.PropTypes.bool,
  highlightEditorIdentityData: _react.PropTypes.shape({
    userId: _react.PropTypes.string,
    teamId: _react.PropTypes.string,
    isAthlete: _react.PropTypes.bool,
    isCoach: _react.PropTypes.bool,
    sport: _react.PropTypes.string
  }),
  logData: _react.PropTypes.object,
  onVideoOverlayClick: _react.PropTypes.func,
  onShareContent: _react.PropTypes.func,
  ownerId: _propTypes.FeedUserId,
  reelId: _react.PropTypes.string.isRequired,
  relatedFeedUser: _propTypes.FeedUser,
  subtitle: _react.PropTypes.string,
  teamId: _react.PropTypes.string,
  thumbnail: _react.PropTypes.shape({
    url: _react.PropTypes.string.isRequired
  }).isRequired,
  title: _react.PropTypes.string,
  userId: _react.PropTypes.string,
  views: _react.PropTypes.number,
  videoFiles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    quality: _react.PropTypes.number,
    url: _react.PropTypes.string
  }))
};
SharedHighlight.contextTypes = {
  store: _react.PropTypes.object
};
exports.default = SharedHighlight;